import React from 'react';
import Header from './../Header';
import Footer from '../Footer';
import Loader from '../Loader';
import Menu from '../Menu';
import MainSlider from './MainSlider';
import ContentSection from './ContentSection';
import RelatedProjects from './../Projects/Details/RelatedProjects';
import { fetchMenu } from "./../../actions/menuActionCreators";
import { fetchPages } from "./../../actions/pageActionCreators";
import { fetchProjects } from "./../../actions/projectActionCreators";
import { fetchOptions } from "./../../actions/optionActionCreators";
import { Helmet } from 'react-helmet';
import ReactHtmlParser from 'react-html-parser';
import ReactFullpage from '@fullpage/react-fullpage';
import ReactGA from 'react-ga';

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			pageLoading: true
		}
	}
	componentDidMount() {
        let page_slug = this.props.match.params.slug;
		ReactGA.pageview('/services/'+page_slug);
		Promise.all([
			this.props.dispatch(fetchMenu('menu')),
			this.props.dispatch(fetchPages()),
			this.props.dispatch(fetchProjects()),
			this.props.dispatch(fetchOptions()),
		]).then(() => {
			this.setState({
				pageLoading: false
			})
		});
    }

	render() {
        let page_slug = this.props.match.params.slug;
		let { menu } = this.props.menu;
        let _this = this;
        let projects = this.props.projects && Object.keys(this.props.projects.data).length ? this.props.projects.data['all'] : [] ;
        let allPageData = this.props.pages.allPageData;
        let page_index = Object.keys(allPageData).filter(key => {
            return allPageData[key].slug === page_slug
        });
        let page_data = allPageData[page_index];
        if(!page_data || !Object.keys(page_data).length) return [];
        let related_projects_arr = page_data.acf.related_projects ? page_data.acf.related_projects : [];
        let related_projects = [];

        if(related_projects_arr && related_projects_arr.length){
            related_projects = projects.filter((item) => {
                return related_projects_arr.indexOf( item.ID ) >= 0;
            });
        }
		const Fullpage = () => (
		<ReactFullpage
			scrollOverflow={true}
			licenseKey={process.env.REACT_APP_FULLPAGE_LICENSE}
			responsiveWidth={process.env.REACT_APP_FULLPAGE_BREAKPOINT}
			afterLoad={
				function (origin, destination, direction) {
					let ham = destination && destination.item && destination.item.attributes['data-hammenu'] ? destination.item.attributes['data-hammenu'].nodeValue : '';
					let dis = destination.isFirst ? 1 : 0;
					if(document.querySelector('header')){
						document.querySelector('.ll-logo').style.opacity = dis;
						if(ham)
							document.querySelector('header').classList.add(ham)
					}
				}
			}
			onLeave={
				function (origin, destination, direction) {
					let dis = destination.isFirst ? 1 : 0;
					if(document.querySelector('header')){
						document.querySelector('header').classList.remove('white')
						document.querySelector('.ll-logo').style.opacity = dis;
					}
				}
			}
			render={({ state, fullpageApi }) => {
				return (
					<ReactFullpage.Wrapper>
						<MainSlider {..._this.props} page_data={page_data} handleClickBelow={() => fullpageApi.moveTo(2)} />
						<ContentSection {..._this.props} page_data={page_data} />
                        <RelatedProjects {..._this.props} related_projects={related_projects} />
						<Footer {..._this.props}  />
					</ReactFullpage.Wrapper>
				);
			}}
		/>
		);
	
		return (
			<div className="fullW">
				{ page_data &&
					<Helmet>
						{ReactHtmlParser(page_data.yoast_head)}
					</Helmet>
				}
				<main className="ll__service-inner fullpage-wrapper">
					{this.state.pageLoading &&
						<Loader />
					} 
                    <Header {..._this.props}  />
					<Fullpage {...this.props} />
				</main>
				{menu.primary &&
					<Menu {..._this.props} />
				}
			</div>
		);
	}
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/Services/index.js